import type { LocalePack } from "./types";

const perks = [
  { title: "Sin depósito de seguridad", text: "Alquila sin tarjeta de crédito ni fianza bloqueada: pagas con tarjeta de débito, efectivo (EUR/RON) o transferencia." },
  { title: "Seguro RCA+CASCO incluido", text: "Todos nuestros coches incluyen seguro a todo riesgo, rovinieta (viñeta de carretera) y kilometraje ilimitado." },
  { title: "Recogida gratuita 24/7", text: "Entrega gratuita en nuestra oficina de Bulevardul Regina Elisabeta 33 o en el aeropuerto Henri Coandă (Otopeni), a cualquier hora." },
  { title: "Atención directa por WhatsApp", text: "Resuelve dudas, cambia tu reserva o pide asistencia en carretera escribiendo al +40738792499." },
];

const otopeniPerks = [
  { title: "Recogida en la terminal", text: "Nuestro equipo te espera en el aeropuerto Henri Coandă (OTP) con el coche listo, sin colas ni mostradores." },
  { title: "Sin cargos ocultos por el aeropuerto", text: "La recogida en Otopeni es gratuita, sin la típica 'tasa de aeropuerto' que cobran otras compañías." },
  { title: "Flota de 28 coches", text: "Desde utilitarios económicos hasta SUV y monovolúmenes de 7 plazas, siempre con seguro y viñeta incluidos." },
  { title: "Devolución flexible", text: "Puedes devolver el vehículo en el aeropuerto o en nuestra oficina del centro de Bucarest, a cualquier hora del día o la noche." },
];

const rulesPerks = [
  { title: "Documentación al día", text: "Todos nuestros coches circulan con la rovinieta vigente y la documentación en regla, sin gestiones para ti." },
  { title: "Asesoramiento antes de viajar", text: "Te explicamos por WhatsApp las normas de tráfico rumanas antes de que salgas a carretera." },
  { title: "Coches revisados", text: "Neumáticos, frenos y luces se revisan antes de cada entrega para que circules con seguridad y sin sorpresas." },
  { title: "Asistencia 24/7", text: "Si tienes cualquier duda legal o mecánica en ruta, te atendemos por WhatsApp en cualquier momento." },
];

const guidePerks = [
  { title: "Coches preparados para carretera", text: "Vehículos revisados y con seguro completo, ideales para rutas largas por montaña o costa." },
  { title: "Kilometraje ilimitado", text: "Recorre toda Rumanía sin preocuparte por límites de distancia ni cargos extra." },
  { title: "Consejos de ruta reales", text: "Te damos recomendaciones prácticas sobre carreteras, paradas y clima antes de tu viaje." },
  { title: "Soporte en ruta por WhatsApp", text: "Estamos disponibles para cualquier imprevisto durante tu recorrido por el país." },
];

export const es: LocalePack = {
  code: "es",
  htmlLang: "es",
  dir: "ltr",
  ui: {
    label: "Español",
    nav: {
      country: "Rumanía",
      airports: "Aeropuertos",
      cities: "Ciudades",
      guides: "Guías de viaje",
    },
    bookCta: "Reservar ahora",
    fleetCta: "Ver flota",
    whatsappCta: "Escríbenos por WhatsApp",
    fleetTitle: "Nuestra flota de coches de alquiler",
    fleetSubtitle: "28 vehículos disponibles, desde económicos hasta monovolúmenes de 7 plazas",
    faqTitle: "Preguntas frecuentes",
    mapTitle: "Dónde estamos",
    relatedTitle: "También te puede interesar",
    priceNote: "Precios desde 35 €/día, seguro y viñeta incluidos",
    breadcrumbHome: "Inicio",
  },
  pages: {
    country: {
      slug: "",
      title: "Alquiler de coches Rumanía | Desde 35 €/día | carentals.ro",
      description: "Alquiler de coches en Rumanía sin depósito ni tarjeta de crédito. Recogida gratis en Bucarest y aeropuerto Otopeni. Seguro y viñeta incluidos.",
      eyebrow: "Alquiler de coches en toda Rumanía",
      h1: "Alquiler de coches Rumanía sin depósito ni sorpresas",
      intro: "En carentals.ro alquilas un coche en Rumanía de forma sencilla, sin fianza bloqueada ni tarjeta de crédito obligatoria. Nuestra flota de 28 vehículos incluye seguro RCA+CASCO, rovinieta y kilometraje ilimitado desde 35 €/día, con recogida gratuita en Bucarest y en el aeropuerto de Otopeni.",
      perks,
      sections: [
        {
          h2: "Por qué alquilar con carentals.ro",
          body: [
            "Somos una empresa de alquiler de coches con sede en Bucarest, en Bulevardul Regina Elisabeta 33, y ofrecemos recogida gratuita tanto en nuestra oficina como en el aeropuerto Henri Coandă. Si necesitas que te entreguemos el coche en otra dirección de Bucarest, el coste es de solo 20 €.",
            "Nuestros precios parten de 35 €/día e incluyen seguro a todo riesgo, viñeta de carretera y kilometraje ilimitado, sin letra pequeña. Puedes pagar con tarjeta de débito, en efectivo (euros o leus) o por transferencia bancaria, sin necesidad de tarjeta de crédito ni depósito de seguridad.",
          ],
        },
        {
          h2: "Cobertura en todo el país",
          body: [
            "Aunque nuestra base está en Bucarest, entregamos vehículos también en los aeropuertos de Cluj, Iași, Timișoara y Sibiu, así como en las principales ciudades del país. La entrega fuera de Bucarest se organiza bajo petición por WhatsApp, con presupuesto personalizado según la distancia.",
            "Esto significa que puedes recoger el coche en un aeropuerto y devolverlo en otro, o combinar ciudades en tu ruta, siempre coordinando los detalles con nuestro equipo antes de viajar.",
          ],
        },
        {
          h2: "Atención personalizada por WhatsApp",
          body: [
            "Todo el proceso de reserva, consulta y asistencia se gestiona de forma ágil por WhatsApp en el +40738792499, disponible las 24 horas del día, los 7 días de la semana.",
            "Nuestro equipo te ayuda a elegir el coche adecuado según tu viaje, ya sea una escapada urbana, una ruta por los Cárpatos o un recorrido por la costa del mar Negro.",
          ],
        },
      ],
      faqs: [
        { q: "¿Necesito tarjeta de crédito para alquilar un coche en Rumanía?", a: "No. En carentals.ro no pedimos tarjeta de crédito ni depósito de seguridad; puedes pagar con tarjeta de débito, efectivo en EUR o RON, o transferencia bancaria." },
        { q: "¿El seguro está incluido en el precio?", a: "Sí, todos nuestros coches incluyen seguro RCA+CASCO, rovinieta y kilometraje ilimitado sin coste adicional." },
        { q: "¿Dónde puedo recoger el coche?", a: "Puedes recogerlo gratis en nuestra oficina de Bucarest o en el aeropuerto Henri Coandă (Otopeni). También entregamos en otras direcciones de Bucarest por 20 €." },
        { q: "¿Puedo alquilar un coche para viajar por toda Rumanía?", a: "Sí, nuestros coches tienen kilometraje ilimitado, así que puedes recorrer el país entero sin restricciones ni cargos extra." },
      ],
      keywords: "alquiler de coches rumania, alquiler coches bucarest, rent a car rumania, alquiler coche rumania sin deposito",
    },
    "airport-otopeni": {
      slug: "alquiler-coche-aeropuerto-bucarest-otopeni",
      title: "Alquiler coche aeropuerto Bucarest Otopeni | carentals.ro",
      description: "Alquiler de coches en el aeropuerto Otopeni (OTP), Bucarest. Recogida gratuita, sin depósito ni tarjeta de crédito. Seguro y viñeta incluidos.",
      eyebrow: "Aeropuerto Henri Coandă (OTP)",
      h1: "Alquiler coche aeropuerto Bucarest Otopeni",
      intro: "Alquila tu coche directamente en el aeropuerto Henri Coandă de Otopeni (OTP) sin pagar tasas adicionales ni depósito de seguridad. Te entregamos el vehículo listo para salir en cuanto aterrizas, las 24 horas del día.",
      perks: otopeniPerks,
      sections: [
        {
          h2: "Recogida rápida en Otopeni",
          body: [
            "En cuanto recojas tu equipaje, nuestro equipo estará esperándote en el aeropuerto Henri Coandă para entregarte las llaves del coche que hayas reservado. No cobramos comisión por recogida en el aeropuerto, a diferencia de muchas otras compañías.",
            "El proceso es rápido: confirmas tu vuelo por WhatsApp al +40738792499 y coordinamos la hora exacta de entrega, incluso si tu vuelo llega de madrugada.",
          ],
        },
        {
          h2: "Sin depósito ni tarjeta de crédito",
          body: [
            "No necesitas tarjeta de crédito ni dejamos ningún importe bloqueado como fianza. Puedes pagar con tarjeta de débito, en efectivo (EUR o RON) o por transferencia bancaria antes de recoger el vehículo.",
            "Esto hace que el alquiler en el aeropuerto de Bucarest sea especialmente cómodo para quienes viajan solo con tarjeta de débito o prefieren pagar en efectivo al llegar.",
          ],
        },
        {
          h2: "Devolución al finalizar tu viaje",
          body: [
            "Puedes devolver el coche en el mismo aeropuerto de Otopeni o en nuestra oficina del centro de Bucarest, según te convenga para tu vuelo de regreso.",
            "Si tu vuelo de salida es muy temprano o muy tarde, no hay problema: nuestro servicio de entrega y recogida funciona las 24 horas, todos los días del año.",
          ],
        },
      ],
      faqs: [
        { q: "¿Cobran algún suplemento por recoger el coche en el aeropuerto?", a: "No, la recogida en el aeropuerto Otopeni es totalmente gratuita, sin tasas adicionales." },
        { q: "¿Qué pasa si mi vuelo llega con retraso?", a: "Seguimos tu vuelo y ajustamos la hora de entrega sin coste extra; solo avísanos por WhatsApp." },
        { q: "¿Puedo devolver el coche en un lugar distinto al aeropuerto?", a: "Sí, puedes devolverlo en nuestra oficina de Bucarest o coordinar otra dirección de entrega." },
        { q: "¿El seguro cubre todo el territorio rumano?", a: "Sí, el seguro RCA+CASCO y la rovinieta son válidos en todas las carreteras de Rumanía." },
      ],
      keywords: "alquiler coche aeropuerto bucarest, alquiler coche otopeni, rent a car otp, alquiler coche aeropuerto henri coanda",
    },
    "airport-cluj": {
      slug: "alquiler-coche-aeropuerto-cluj",
      title: "Alquiler de coches aeropuerto Cluj (CLJ) | carentals.ro",
      description: "Alquiler de coches con entrega en el aeropuerto de Cluj-Napoca. Coordinación por WhatsApp, sin depósito ni tarjeta de crédito.",
      eyebrow: "Aeropuerto de Cluj-Napoca (CLJ)",
      h1: "Alquiler de coches en el aeropuerto de Cluj",
      intro: "Si viajas a Transilvania, podemos entregarte el coche en el aeropuerto de Cluj-Napoca (CLJ). Al estar basados en Bucarest, la entrega en Cluj se organiza bajo petición por WhatsApp, con un presupuesto claro según la distancia.",
      perks,
      sections: [
        {
          h2: "Cómo funciona la entrega en Cluj",
          body: [
            "Nuestra flota está en Bucarest, así que la entrega en el aeropuerto de Cluj se coordina caso por caso: contáctanos por WhatsApp al +40738792499 con tus fechas y te confirmamos disponibilidad y coste de traslado del vehículo.",
            "Somos totalmente transparentes: te indicamos el precio final antes de confirmar la reserva, sin cargos sorpresa una vez en el aeropuerto.",
          ],
        },
        {
          h2: "Un coche ideal para Transilvania",
          body: [
            "Cluj es la puerta de entrada perfecta para explorar castillos, ciudades medievales y los paisajes de Transilvania. Nuestros coches incluyen seguro completo y kilometraje ilimitado para que recorras la región sin límites.",
            "Recomendamos reservar con antelación cuando el punto de recogida es Cluj, ya que la logística de traslado requiere organizarse con tiempo.",
          ],
        },
        {
          h2: "Devolución y rutas combinadas",
          body: [
            "Puedes devolver el coche en el mismo aeropuerto de Cluj o, si tu ruta continúa hacia Bucarest, entregarlo en nuestra oficina o en Otopeni al finalizar el viaje.",
            "También es posible combinar recogida en Cluj y devolución en otro aeropuerto rumano; consúltanos la disponibilidad y el coste exacto por WhatsApp.",
          ],
        },
      ],
      faqs: [
        { q: "¿Tienen coches disponibles directamente en Cluj?", a: "Nuestra flota parte de Bucarest; la entrega en Cluj se organiza bajo petición, con presupuesto según distancia." },
        { q: "¿Con cuánta antelación debo reservar?", a: "Recomendamos al menos una semana de antelación para coordinar bien el traslado del vehículo hasta Cluj." },
        { q: "¿Puedo devolver el coche en otra ciudad?", a: "Sí, es posible una devolución en otra ciudad o aeropuerto; te damos el presupuesto exacto según tu ruta." },
        { q: "¿El precio incluye seguro y viñeta?", a: "Sí, todos nuestros alquileres incluyen seguro RCA+CASCO, rovinieta y kilometraje ilimitado." },
      ],
      keywords: "alquiler coche aeropuerto cluj, rent a car cluj napoca, alquiler coches cluj",
    },
    "airport-iasi": {
      slug: "alquiler-coche-aeropuerto-iasi",
      title: "Alquiler de coches aeropuerto Iași (IAS) | carentals.ro",
      description: "Alquiler de coches con entrega en el aeropuerto de Iași. Coordinamos el traslado desde Bucarest bajo petición, sin depósito ni tarjeta de crédito.",
      eyebrow: "Aeropuerto de Iași (IAS)",
      h1: "Alquiler de coches en el aeropuerto de Iași",
      intro: "Para quienes llegan al aeropuerto de Iași, en el noreste de Rumanía, ofrecemos entrega del vehículo bajo petición vía WhatsApp. Como nuestra base está en Bucarest, el traslado se presupuesta según la distancia y las fechas de tu viaje.",
      perks,
      sections: [
        {
          h2: "Entrega bajo petición en Iași",
          body: [
            "Escríbenos al +40738792499 indicando tus fechas de llegada y salida en Iași, y te confirmaremos si podemos entregarte el coche allí y cuál sería el coste del traslado desde Bucarest.",
            "Al ser un servicio a medida, siempre te damos el presupuesto cerrado antes de confirmar la reserva, sin sorpresas al recoger el vehículo.",
          ],
        },
        {
          h2: "Explora Moldavia y los monasterios pintados",
          body: [
            "Iași es el punto de partida ideal para visitar los famosos monasterios pintados de Bucovina y la región histórica de Moldavia. Nuestros coches incluyen kilometraje ilimitado para que no tengas que preocuparte por los kilómetros recorridos.",
            "El seguro RCA+CASCO y la rovinieta están incluidos en todos los alquileres, también cuando la recogida se realiza fuera de Bucarest.",
          ],
        },
        {
          h2: "Flexibilidad para tu ruta",
          body: [
            "Si tu viaje continúa hacia otra ciudad o aeropuerto rumano, podemos estudiar una devolución en un punto distinto al de recogida, siempre con presupuesto previo.",
            "Contáctanos con la mayor antelación posible para asegurar la disponibilidad del vehículo en la fecha que necesitas.",
          ],
        },
      ],
      faqs: [
        { q: "¿Puedo alquilar un coche directamente en el aeropuerto de Iași?", a: "Sí, coordinamos la entrega bajo petición por WhatsApp, con presupuesto según la distancia desde Bucarest." },
        { q: "¿Cuánto cuesta el traslado del coche hasta Iași?", a: "Depende de las fechas y la disponibilidad; te damos un presupuesto exacto al contactarnos." },
        { q: "¿El seguro es válido en toda la región de Moldavia?", a: "Sí, el seguro y la rovinieta cubren todo el territorio de Rumanía." },
        { q: "¿Puedo devolver el coche en otro aeropuerto?", a: "Es posible bajo petición; consúltanos la disponibilidad y el coste para tu ruta concreta." },
      ],
      keywords: "alquiler coche aeropuerto iasi, rent a car iasi, alquiler coches iasi rumania",
    },
    "airport-timisoara": {
      slug: "alquiler-coche-aeropuerto-timisoara",
      title: "Alquiler de coches aeropuerto Timișoara (TSR) | carentals.ro",
      description: "Alquiler de coches con entrega en el aeropuerto de Timișoara. Traslado desde Bucarest bajo petición, sin depósito ni tarjeta de crédito.",
      eyebrow: "Aeropuerto de Timișoara (TSR)",
      h1: "Alquiler de coches en el aeropuerto de Timișoara",
      intro: "Ofrecemos entrega de vehículos en el aeropuerto de Timișoara, al oeste de Rumanía, coordinada bajo petición por WhatsApp. Nuestra base está en Bucarest, así que el traslado del coche se presupuesta según la distancia.",
      perks,
      sections: [
        {
          h2: "Cómo reservar para Timișoara",
          body: [
            "Escríbenos al +40738792499 con tus fechas de viaje y te confirmaremos si podemos entregar el vehículo en el aeropuerto de Timișoara y el coste asociado al traslado desde Bucarest.",
            "Trabajamos con presupuesto cerrado desde el primer momento, para que sepas exactamente cuánto pagarás antes de confirmar tu reserva.",
          ],
        },
        {
          h2: "El oeste de Rumanía en coche",
          body: [
            "Timișoara es un excelente punto de partida para explorar el Banat y las montañas del oeste del país. Nuestros vehículos incluyen kilometraje ilimitado, seguro RCA+CASCO y rovinieta sin coste adicional.",
            "Recomendamos reservar con suficiente antelación para garantizar la disponibilidad del coche en la fecha y el punto de entrega que necesitas.",
          ],
        },
        {
          h2: "Devolución flexible",
          body: [
            "Si tu itinerario lo requiere, podemos estudiar la devolución del vehículo en otra ciudad o aeropuerto rumano, siempre con un presupuesto claro de antemano.",
            "Contacta con nuestro equipo lo antes posible para coordinar los detalles logísticos de tu viaje.",
          ],
        },
      ],
      faqs: [
        { q: "¿Entregan coches en el aeropuerto de Timișoara?", a: "Sí, bajo petición y con presupuesto según la distancia desde nuestra base en Bucarest." },
        { q: "¿Necesito tarjeta de crédito?", a: "No, puedes pagar con tarjeta de débito, efectivo en EUR/RON o transferencia bancaria." },
        { q: "¿El kilometraje es ilimitado también en esta zona?", a: "Sí, el kilometraje ilimitado se aplica en todo el territorio rumano." },
        { q: "¿Puedo reservar con poca antelación?", a: "Es posible, pero recomendamos avisar con tiempo para asegurar la disponibilidad del traslado." },
      ],
      keywords: "alquiler coche aeropuerto timisoara, rent a car timisoara, alquiler coches timisoara rumania",
    },
    "airport-sibiu": {
      slug: "alquiler-coche-aeropuerto-sibiu",
      title: "Alquiler de coches aeropuerto Sibiu (SBZ) | carentals.ro",
      description: "Alquiler de coches con entrega en el aeropuerto de Sibiu. Traslado desde Bucarest bajo petición, sin depósito ni tarjeta de crédito.",
      eyebrow: "Aeropuerto de Sibiu (SBZ)",
      h1: "Alquiler de coches en el aeropuerto de Sibiu",
      intro: "Podemos entregar tu coche de alquiler en el aeropuerto de Sibiu, en pleno corazón de Transilvania, cerca de la Transfăgărășan. La entrega se coordina bajo petición por WhatsApp, con presupuesto según la distancia desde Bucarest.",
      perks,
      sections: [
        {
          h2: "Reserva con entrega en Sibiu",
          body: [
            "Contáctanos al +40738792499 con tus fechas y te indicaremos si es posible entregar el vehículo en el aeropuerto de Sibiu y cuál sería el coste del traslado.",
            "El presupuesto se cierra antes de la reserva, para que viajes con total tranquilidad sobre el precio final.",
          ],
        },
        {
          h2: "Punto de partida hacia la Transfăgărășan",
          body: [
            "Sibiu es una de las mejores bases para conducir la famosa carretera Transfăgărășan y explorar las fortalezas sajonas de Transilvania. Nuestros coches incluyen seguro completo, rovinieta y kilometraje ilimitado.",
            "Si tu ruta incluye montaña, te recomendamos consultarnos sobre las condiciones de la carretera según la época del año antes de salir.",
          ],
        },
        {
          h2: "Devolución según tu itinerario",
          body: [
            "Puedes devolver el coche en el mismo aeropuerto de Sibiu o coordinar la entrega en otra ciudad si tu viaje continúa por Rumanía.",
            "Escríbenos con antelación para reservar la fecha y el punto exacto de recogida y devolución.",
          ],
        },
      ],
      faqs: [
        { q: "¿Puedo recoger el coche en el aeropuerto de Sibiu?", a: "Sí, bajo petición y con presupuesto según la distancia desde Bucarest." },
        { q: "¿Es buena base para conducir la Transfăgărășan?", a: "Sí, Sibiu está muy cerca del inicio de esta famosa carretera de montaña." },
        { q: "¿Incluye seguro para carreteras de montaña?", a: "Sí, el seguro RCA+CASCO cubre todo el territorio rumano, incluidas las zonas de montaña." },
        { q: "¿Cuánto tiempo antes debo reservar?", a: "Recomendamos al menos una semana de antelación para organizar bien el traslado del vehículo." },
      ],
      keywords: "alquiler coche aeropuerto sibiu, rent a car sibiu, alquiler coches sibiu rumania",
    },
    "city-bucharest": {
      slug: "alquiler-coches-bucarest",
      title: "Alquiler de coches en Bucarest | carentals.ro",
      description: "Alquiler de coches en Bucarest sin depósito ni tarjeta de crédito. Recogida gratis en el centro o en el aeropuerto Otopeni.",
      eyebrow: "Alquiler de coches en la capital",
      h1: "Alquiler de coches en Bucarest",
      intro: "Alquila tu coche en pleno centro de Bucarest, en Bulevardul Regina Elisabeta 33, con recogida gratuita y sin depósito de seguridad. También entregamos gratis en el aeropuerto Otopeni y en cualquier otra dirección de la ciudad por 20 €.",
      perks,
      sections: [
        {
          h2: "Oficina en el centro de Bucarest",
          body: [
            "Nuestra oficina está en Bulevardul Regina Elisabeta 33, a pocos minutos del centro histórico y bien comunicada con el resto de la ciudad. Puedes recoger el coche allí de forma gratuita, sin cita previa complicada.",
            "Si prefieres que te lo llevemos a tu hotel o apartamento en Bucarest, el servicio de entrega tiene un coste de 20 € y se coordina fácilmente por WhatsApp.",
          ],
        },
        {
          h2: "Moverse por Bucarest y sus alrededores",
          body: [
            "Un coche de alquiler te permite explorar Bucarest a tu ritmo y salir fácilmente hacia destinos cercanos como Snagov, Sinaia o el castillo de Peleș, sin depender del transporte público.",
            "Nuestra flota incluye desde utilitarios compactos ideales para el tráfico urbano hasta SUV más cómodos para excursiones de un día fuera de la ciudad.",
          ],
        },
        {
          h2: "Reserva sencilla y sin sorpresas",
          body: [
            "El precio incluye seguro RCA+CASCO, rovinieta y kilometraje ilimitado desde 35 €/día, sin depósito de seguridad ni necesidad de tarjeta de crédito.",
            "Escríbenos por WhatsApp al +40738792499 y en pocos minutos tendrás confirmada tu reserva con el coche y las fechas que necesitas.",
          ],
        },
      ],
      faqs: [
        { q: "¿Dónde está la oficina de recogida en Bucarest?", a: "En Bulevardul Regina Elisabeta 33, en el centro de la ciudad, con recogida totalmente gratuita." },
        { q: "¿Puedo pedir que me lleven el coche a mi hotel?", a: "Sí, la entrega en cualquier otra dirección de Bucarest tiene un coste de 20 €." },
        { q: "¿Hace falta tarjeta de crédito para reservar en Bucarest?", a: "No, aceptamos tarjeta de débito, efectivo en EUR/RON o transferencia bancaria, sin depósito de seguridad." },
        { q: "¿Puedo usar el coche para salir de Bucarest?", a: "Por supuesto, el kilometraje ilimitado te permite visitar Sinaia, Brasov o cualquier otro destino sin restricciones." },
      ],
      keywords: "alquiler de coches bucarest, rent a car bucarest, alquiler coche centro bucarest",
    },
    "city-brasov": {
      slug: "alquiler-coches-brasov",
      title: "Alquiler de coches en Brașov | carentals.ro",
      description: "Alquiler de coches con entrega en Brașov. Coordinamos el traslado desde Bucarest, sin depósito ni tarjeta de crédito.",
      eyebrow: "Alquiler de coches en Transilvania",
      h1: "Alquiler de coches en Brașov",
      intro: "Aunque nuestra base está en Bucarest, podemos entregarte el coche en Brașov bajo petición, con presupuesto según la distancia. Brașov es la puerta de entrada perfecta a los castillos de Transilvania y a la carretera Transfăgărășan.",
      perks,
      sections: [
        {
          h2: "Entrega en Brașov bajo petición",
          body: [
            "Contáctanos por WhatsApp al +40738792499 con tus fechas de viaje y te confirmaremos la disponibilidad y el coste de trasladar el vehículo desde Bucarest hasta Brașov.",
            "Al tratarse de un servicio personalizado, siempre recibirás el presupuesto exacto antes de confirmar tu reserva.",
          ],
        },
        {
          h2: "Explora Transilvania desde Brașov",
          body: [
            "Desde Brașov puedes visitar fácilmente el castillo de Bran, la fortaleza de Râșnov y la ciudad medieval de Sighișoara. Nuestros coches incluyen kilometraje ilimitado para que no tengas límites en tu ruta.",
            "El seguro RCA+CASCO y la rovinieta están incluidos también cuando la entrega se realiza fuera de Bucarest, sin coste adicional en la cobertura.",
          ],
        },
        {
          h2: "Alternativa: recoger en Bucarest",
          body: [
            "Si prefieres evitar el coste del traslado a Brașov, también puedes recoger el coche gratis en nuestra oficina de Bucarest o en el aeropuerto Otopeni y conducir tú mismo hasta la ciudad, a menos de dos horas.",
            "Muchos clientes eligen esta opción para ahorrar en el coste de entrega y aprovechar el trayecto como parte de su viaje por Transilvania.",
          ],
        },
      ],
      faqs: [
        { q: "¿Puedo recoger el coche directamente en Brașov?", a: "Sí, bajo petición y con presupuesto según la distancia desde Bucarest." },
        { q: "¿Es más barato recoger el coche en Bucarest?", a: "Sí, la recogida en Bucarest u Otopeni es gratuita; el traslado a Brașov tiene un coste adicional según distancia." },
        { q: "¿Qué lugares puedo visitar cerca de Brașov?", a: "El castillo de Bran, Râșnov, Sighișoara y el inicio de la carretera Transfăgărășan." },
        { q: "¿El seguro cubre carreteras de montaña?", a: "Sí, el seguro RCA+CASCO cubre todo el territorio rumano, incluidas las zonas de montaña." },
      ],
      keywords: "alquiler coches brasov, rent a car brasov, alquiler coche brasov transilvania",
    },
    "city-cluj": {
      slug: "alquiler-coches-cluj-napoca",
      title: "Alquiler de coches en Cluj-Napoca | carentals.ro",
      description: "Alquiler de coches con entrega en Cluj-Napoca. Coordinamos el traslado desde Bucarest, sin depósito ni tarjeta de crédito.",
      eyebrow: "Alquiler de coches en Transilvania",
      h1: "Alquiler de coches en Cluj-Napoca",
      intro: "Ofrecemos entrega de vehículos en Cluj-Napoca bajo petición, con presupuesto según la distancia desde nuestra base en Bucarest. Cluj es una excelente base para explorar Transilvania y sus ciudades históricas.",
      perks,
      sections: [
        {
          h2: "Cómo reservar en Cluj-Napoca",
          body: [
            "Escríbenos al +40738792499 con tus fechas de viaje y te confirmaremos si podemos entregar el coche en Cluj-Napoca, junto con el coste del traslado desde Bucarest.",
            "Siempre te damos un presupuesto cerrado antes de la reserva, para que no haya sorpresas al recoger el vehículo.",
          ],
        },
        {
          h2: "Cluj, capital cultural de Transilvania",
          body: [
            "Desde Cluj-Napoca puedes visitar fácilmente ciudades como Turda, con su famosa salina, o adentrarte en los paisajes rurales de Transilvania. Nuestros coches tienen kilometraje ilimitado para explorar sin límites.",
            "Todos los alquileres incluyen seguro RCA+CASCO y rovinieta, también cuando el punto de recogida está fuera de Bucarest.",
          ],
        },
        {
          h2: "Planifica tu ruta con antelación",
          body: [
            "Debido a la distancia entre Bucarest y Cluj, recomendamos reservar con al menos una semana de antelación para garantizar la disponibilidad del vehículo.",
            "Si tu viaje continúa hacia otra ciudad, podemos estudiar la devolución en un punto distinto al de recogida.",
          ],
        },
      ],
      faqs: [
        { q: "¿Entregan coches directamente en Cluj-Napoca?", a: "Sí, bajo petición, con presupuesto según la distancia desde Bucarest." },
        { q: "¿Qué lugares puedo visitar desde Cluj?", a: "La salina de Turda, los pueblos sajones de Transilvania y numerosos castillos históricos." },
        { q: "¿Puedo devolver el coche en otra ciudad?", a: "Sí, consúltanos la disponibilidad y el coste según tu ruta concreta." },
        { q: "¿Con cuánta antelación debo reservar?", a: "Recomendamos al menos una semana para organizar bien el traslado del vehículo." },
      ],
      keywords: "alquiler coches cluj napoca, rent a car cluj, alquiler coche cluj transilvania",
    },
    "city-constanta": {
      slug: "alquiler-coches-constanta",
      title: "Alquiler de coches en Constanța | carentals.ro",
      description: "Alquiler de coches con entrega en Constanța y la costa del mar Negro. Coordinamos el traslado desde Bucarest, sin depósito.",
      eyebrow: "Alquiler de coches en la costa",
      h1: "Alquiler de coches en Constanța",
      intro: "Podemos entregarte el coche en Constanța para que disfrutes de la costa rumana del mar Negro. La entrega se coordina bajo petición por WhatsApp, con presupuesto según la distancia desde Bucarest.",
      perks,
      sections: [
        {
          h2: "Entrega en Constanța bajo petición",
          body: [
            "Contáctanos al +40738792499 con tus fechas y te indicaremos si podemos entregar el vehículo en Constanța y cuál sería el coste del traslado desde nuestra base en Bucarest.",
            "Recibirás el presupuesto completo antes de confirmar la reserva, sin cargos ocultos al recoger el coche.",
          ],
        },
        {
          h2: "La costa del mar Negro en coche",
          body: [
            "Constanța es el punto de partida ideal para recorrer la costa rumana, desde Mamaia hasta Vama Veche. Nuestros coches incluyen kilometraje ilimitado, así que puedes explorar toda la zona sin restricciones.",
            "El seguro RCA+CASCO y la rovinieta están incluidos también en los alquileres con recogida en Constanța.",
          ],
        },
        {
          h2: "Alternativa: recoger en Bucarest",
          body: [
            "Constanța está a poco más de dos horas de Bucarest, así que muchos clientes prefieren recoger el coche gratis en nuestra oficina o en el aeropuerto Otopeni y conducir directamente hasta la costa.",
            "Esta opción evita el coste de traslado y te permite empezar tu ruta por la costa nada más recoger el vehículo.",
          ],
        },
      ],
      faqs: [
        { q: "¿Puedo recoger el coche en Constanța directamente?", a: "Sí, bajo petición y con presupuesto según la distancia desde Bucarest." },
        { q: "¿Es mejor recoger el coche en Bucarest para ir a la costa?", a: "Muchos clientes lo prefieren así, ya que la recogida en Bucarest es gratuita y Constanța está a poco más de dos horas." },
        { q: "¿Qué playas puedo visitar con el coche de alquiler?", a: "Mamaia, Costinești, Vama Veche y muchas otras playas de la costa rumana." },
        { q: "¿El kilometraje ilimitado aplica también en la costa?", a: "Sí, se aplica en todo el territorio rumano sin excepciones." },
      ],
      keywords: "alquiler coches constanta, rent a car constanta, alquiler coche costa mar negro rumania",
    },
    cheap: {
      slug: "alquiler-de-coches-baratos-rumania",
      title: "Alquiler de coches baratos en Rumanía desde 35 €/día",
      description: "Alquiler de coches económicos en Rumanía desde 35 €/día, seguro y viñeta incluidos. Sin depósito ni tarjeta de crédito.",
      eyebrow: "Precios desde 35 €/día",
      h1: "Alquiler de coches baratos en Rumanía",
      intro: "Encuentra el alquiler de coches más económico en Rumanía con carentals.ro, desde 35 €/día con seguro RCA+CASCO, rovinieta y kilometraje ilimitado incluidos. Sin depósito de seguridad ni tarjeta de crédito obligatoria.",
      perks,
      sections: [
        {
          h2: "Precios claros, sin letra pequeña",
          body: [
            "Nuestros precios parten de 35 €/día e incluyen todo lo esencial: seguro a todo riesgo, rovinieta y kilometraje ilimitado, así que el precio que ves es el precio final que pagas.",
            "No cobramos comisión por recogida en el aeropuerto de Otopeni ni pedimos depósito de seguridad, dos gastos habituales en otras compañías que aquí te ahorras.",
          ],
        },
        {
          h2: "Cómo conseguir el mejor precio",
          body: [
            "Reservar con antelación y elegir modelos compactos suele ser la forma más económica de alquilar en Rumanía, especialmente si viajas fuera de temporada alta.",
            "Escríbenos por WhatsApp al +40738792499 indicando tus fechas y te recomendaremos el coche más económico disponible para tu viaje.",
          ],
        },
        {
          h2: "Ahorra también en el pago",
          body: [
            "Al no exigir tarjeta de crédito ni depósito bloqueado, puedes pagar con tarjeta de débito, efectivo en EUR o RON, o transferencia bancaria, sin comisiones adicionales.",
            "Esto hace que el coste total de tu alquiler sea predecible desde el primer momento, sin cargos sorpresa a la devolución del vehículo.",
          ],
        },
      ],
      faqs: [
        { q: "¿Cuál es el precio mínimo de alquiler?", a: "Nuestros precios parten de 35 €/día, con seguro, rovinieta y kilometraje ilimitado incluidos." },
        { q: "¿Hay algún cargo oculto?", a: "No, el precio incluye todo lo esencial y no cobramos comisión por recogida en el aeropuerto." },
        { q: "¿Necesito tarjeta de crédito para conseguir el precio más bajo?", a: "No, aceptamos débito, efectivo y transferencia sin necesidad de tarjeta de crédito." },
        { q: "¿Cómo reservo el coche más económico?", a: "Escríbenos por WhatsApp con tus fechas y te indicaremos la opción más barata disponible." },
      ],
      keywords: "alquiler coches baratos rumania, alquiler coche economico rumania, rent a car barato rumania",
    },
    automatic: {
      slug: "alquiler-coche-automatico-rumania",
      title: "Alquiler de coches automáticos en Rumanía | carentals.ro",
      description: "Alquila un coche con cambio automático en Rumanía. Seguro y viñeta incluidos, sin depósito ni tarjeta de crédito.",
      eyebrow: "Cambio automático",
      h1: "Alquiler de coches con cambio automático en Rumanía",
      intro: "Si prefieres conducir sin embrague, en carentals.ro tenemos coches con cambio automático disponibles en nuestra flota de 28 vehículos, ideales para el tráfico de Bucarest o para rutas largas por carretera.",
      perks,
      sections: [
        {
          h2: "Comodidad al volante",
          body: [
            "Un coche automático facilita mucho la conducción en el tráfico denso de Bucarest y en trayectos largos, como la costa del mar Negro o las carreteras de montaña de Transilvania.",
            "Todos nuestros modelos automáticos incluyen el mismo seguro RCA+CASCO, rovinieta y kilometraje ilimitado que el resto de la flota, sin coste adicional por el tipo de cambio.",
          ],
        },
        {
          h2: "Disponibilidad limitada, reserva con tiempo",
          body: [
            "Los coches automáticos suelen tener menos unidades disponibles que los de cambio manual, por lo que recomendamos reservar con antelación, especialmente en temporada alta.",
            "Escríbenos por WhatsApp al +40738792499 indicando que buscas un cambio automático y te confirmaremos la disponibilidad para tus fechas exactas.",
          ],
        },
        {
          h2: "Ideal para conductores no habituados a Rumanía",
          body: [
            "Si no estás familiarizado con la conducción en Rumanía, un coche automático te permite concentrarte mejor en la señalización y el tráfico, sin la distracción del cambio de marchas.",
            "Nuestro equipo puede recomendarte el modelo automático más adecuado según el tipo de ruta que tengas planeada.",
          ],
        },
      ],
      faqs: [
        { q: "¿Tienen coches automáticos disponibles?", a: "Sí, contamos con varios modelos de cambio automático dentro de nuestra flota de 28 vehículos." },
        { q: "¿El precio es distinto al de un coche manual?", a: "El precio depende del modelo elegido, pero incluye siempre seguro, rovinieta y kilometraje ilimitado." },
        { q: "¿Debo reservar con más antelación un coche automático?", a: "Sí, recomendamos reservar con tiempo porque hay menos unidades disponibles que en cambio manual." },
        { q: "¿Puedo pedir un automático para recogida en el aeropuerto?", a: "Sí, indícanoslo por WhatsApp al reservar y te lo prepararemos en Otopeni o en nuestra oficina." },
      ],
      keywords: "alquiler coche automatico rumania, rent a car automatico bucarest, coche cambio automatico rumania",
    },
    "unlimited-km": {
      slug: "alquiler-coche-kilometraje-ilimitado-rumania",
      title: "Alquiler de coches con kilometraje ilimitado en Rumanía",
      description: "Alquila un coche en Rumanía con kilometraje ilimitado incluido en todos nuestros vehículos. Sin depósito ni tarjeta de crédito.",
      eyebrow: "Kilometraje ilimitado incluido",
      h1: "Alquiler de coches con kilometraje ilimitado",
      intro: "Todos los coches de carentals.ro incluyen kilometraje ilimitado de serie, sin coste adicional ni límites de distancia. Recorre Rumanía de punta a punta sin preocuparte por cargos extra al devolver el vehículo.",
      perks,
      sections: [
        {
          h2: "Sin límites en tu ruta",
          body: [
            "Da igual si tu plan es hacer una escapada corta por Bucarest o recorrer todo el país en un road trip de dos semanas: el kilometraje ilimitado está incluido en el precio desde el primer día.",
            "Esto evita las típicas sorpresas de otras compañías que cobran un extra por cada kilómetro que superes el límite contratado.",
          ],
        },
        {
          h2: "Perfecto para rutas largas",
          body: [
            "Rutas como la Transfăgărășan, la costa del mar Negro o un recorrido completo por Transilvania implican cientos de kilómetros, y con nosotros puedes hacerlos sin calcular ni controlar la distancia recorrida.",
            "El seguro RCA+CASCO y la rovinieta también están incluidos, así que el único gasto extra que podrías tener es el combustible.",
          ],
        },
        {
          h2: "Transparencia total en el contrato",
          body: [
            "En el contrato de alquiler se indica claramente que el kilometraje es ilimitado, sin condiciones ocultas ni cláusulas confusas sobre el uso del vehículo.",
            "Si tienes dudas sobre tu ruta planeada, escríbenos por WhatsApp al +40738792499 y te confirmamos que puedes recorrerla sin ningún problema.",
          ],
        },
      ],
      faqs: [
        { q: "¿El kilometraje ilimitado tiene algún coste adicional?", a: "No, está incluido de serie en el precio de todos nuestros alquileres." },
        { q: "¿Aplica en todos los modelos de la flota?", a: "Sí, todos los 28 vehículos de nuestra flota incluyen kilometraje ilimitado." },
        { q: "¿Puedo salir de Rumanía con el coche?", a: "Consúltanos por WhatsApp las condiciones específicas si planeas cruzar a otro país." },
        { q: "¿Hay algún límite de días para el kilometraje ilimitado?", a: "No, se aplica durante toda la duración de tu alquiler, sin importar los días contratados." },
      ],
      keywords: "alquiler coche kilometraje ilimitado rumania, rent a car km ilimitado rumania",
    },
    "one-way": {
      slug: "alquiler-coche-un-solo-sentido-rumania",
      title: "Alquiler de coches de un solo sentido en Rumanía",
      description: "Alquila un coche en una ciudad y devuélvelo en otra. Servicio de un solo sentido bajo petición, con presupuesto por WhatsApp.",
      eyebrow: "Recogida y devolución en distintos puntos",
      h1: "Alquiler de coches de un solo sentido (one-way) en Rumanía",
      intro: "Si necesitas recoger el coche en una ciudad y devolverlo en otra, ofrecemos alquiler de un solo sentido bajo petición. Contáctanos por WhatsApp con tu ruta y te damos un presupuesto exacto para el traslado del vehículo.",
      perks,
      sections: [
        {
          h2: "Cómo funciona el alquiler one-way",
          body: [
            "Escríbenos al +40738792499 indicando en qué ciudad o aeropuerto quieres recoger el coche y en cuál planeas devolverlo. Te confirmamos disponibilidad y el coste del servicio según la distancia entre ambos puntos.",
            "Este servicio es especialmente útil para quienes hacen una ruta lineal por Rumanía, como Bucarest–Brașov–Cluj, sin necesidad de volver al punto de partida.",
          ],
        },
        {
          h2: "Rutas populares de un solo sentido",
          body: [
            "Combinaciones habituales incluyen Bucarest–Otopeni con devolución en Cluj, Sibiu o Brașov, o recorridos que terminan en la costa del mar Negro, en Constanța.",
            "En todos los casos, el coche mantiene su seguro RCA+CASCO, rovinieta y kilometraje ilimitado, sin importar en qué ciudad finalice el alquiler.",
          ],
        },
        {
          h2: "Presupuesto claro antes de reservar",
          body: [
            "Siempre recibirás el precio total del servicio one-way antes de confirmar tu reserva, incluyendo el coste de reposicionamiento del vehículo.",
            "Cuanto antes nos contactes con los detalles de tu ruta, más fácil será garantizarte el coche exacto que necesitas en las fechas que buscas.",
          ],
        },
      ],
      faqs: [
        { q: "¿Puedo recoger el coche en Bucarest y devolverlo en otra ciudad?", a: "Sí, ofrecemos este servicio bajo petición, con presupuesto según la distancia." },
        { q: "¿Cuesta más que un alquiler normal?", a: "Sí, hay un coste adicional por el reposicionamiento del vehículo, que te indicamos antes de confirmar." },
        { q: "¿En qué ciudades puedo devolver el coche?", a: "Podemos estudiar la devolución en cualquier ciudad o aeropuerto principal de Rumanía." },
        { q: "¿El seguro cambia si es un alquiler one-way?", a: "No, se mantiene el mismo seguro RCA+CASCO y rovinieta durante todo el alquiler." },
      ],
      keywords: "alquiler coche un solo sentido rumania, one way car rental rumania, alquiler coche devolucion distinta ciudad",
    },
    "seven-seater": {
      slug: "alquiler-monovolumen-7-plazas-rumania",
      title: "Alquiler de monovolúmenes 7 plazas en Rumanía",
      description: "Alquila un monovolumen de 7 plazas en Rumanía, ideal para familias o grupos. Seguro y viñeta incluidos, sin depósito.",
      eyebrow: "Coches de 7 plazas",
      h1: "Alquiler de monovolúmenes de 7 plazas en Rumanía",
      intro: "Para familias numerosas o grupos de amigos, en carentals.ro disponemos de monovolúmenes de 7 plazas dentro de nuestra flota de 28 vehículos, con seguro RCA+CASCO, rovinieta y kilometraje ilimitado incluidos.",
      perks,
      sections: [
        {
          h2: "Espacio y comodidad para todos",
          body: [
            "Nuestros monovolúmenes de 7 plazas ofrecen espacio suficiente para toda la familia o el grupo, además de amplio maletero para el equipaje de un viaje largo por Rumanía.",
            "Son ideales tanto para desplazamientos por Bucarest como para rutas por carretera hacia la costa del mar Negro o Transilvania, con todos los pasajeros cómodos.",
          ],
        },
        {
          h2: "Reserva con antelación",
          body: [
            "Los vehículos de 7 plazas tienen menos unidades disponibles que los turismos estándar, por lo que recomendamos reservar con tiempo, especialmente en temporada alta y vacaciones.",
            "Escríbenos por WhatsApp al +40738792499 con tus fechas y el número de pasajeros para confirmar la disponibilidad de un monovolumen.",
          ],
        },
        {
          h2: "Mismo precio transparente, sin depósito",
          body: [
            "Al igual que el resto de la flota, los monovolúmenes de 7 plazas no requieren depósito de seguridad ni tarjeta de crédito, y aceptan pago con débito, efectivo o transferencia.",
            "El seguro completo, la rovinieta y el kilometraje ilimitado están incluidos también en estos vehículos, sin coste adicional por ser un modelo más grande.",
          ],
        },
      ],
      faqs: [
        { q: "¿Tienen coches de 7 plazas disponibles?", a: "Sí, contamos con monovolúmenes de 7 plazas dentro de nuestra flota de 28 vehículos." },
        { q: "¿Necesito reservar con más antelación este tipo de coche?", a: "Sí, recomendamos reservar con tiempo porque hay menos unidades disponibles." },
        { q: "¿El precio incluye seguro y viñeta también en 7 plazas?", a: "Sí, todos nuestros vehículos incluyen seguro RCA+CASCO, rovinieta y kilometraje ilimitado." },
        { q: "¿Puedo recoger el monovolumen en el aeropuerto de Otopeni?", a: "Sí, la recogida gratuita en el aeropuerto también está disponible para los coches de 7 plazas." },
      ],
      keywords: "alquiler monovolumen 7 plazas rumania, alquiler coche familiar rumania, rent a car 7 plazas bucarest",
    },
    "guide-transfagarasan": {
      slug: "guia-carretera-transfagarasan-en-coche",
      title: "Guía: cómo recorrer la Transfăgărășan en coche",
      description: "Guía práctica para conducir la Transfăgărășan en Rumanía: cuándo ir, qué llevar y con qué coche alquilar. Consejos reales de carentals.ro.",
      eyebrow: "Guía de carretera",
      h1: "Cómo recorrer la Transfăgărășan en coche",
      intro: "La Transfăgărășan es una de las carreteras de montaña más espectaculares de Europa, y recorrerla en coche de alquiler es la mejor forma de disfrutarla a tu ritmo. Te contamos todo lo necesario para planear tu ruta con carentals.ro.",
      perks: guidePerks,
      sections: [
        {
          h2: "Cuándo conducir la Transfăgărășan",
          body: [
            "La carretera suele estar abierta al tráfico entre finales de junio y finales de octubre, dependiendo de la nieve; el resto del año permanece cerrada en sus tramos más altos por seguridad.",
            "Te recomendamos consultarnos por WhatsApp antes de tu viaje para confirmar el estado de la carretera en las fechas exactas de tu visita.",
          ],
        },
        {
          h2: "Qué coche elegir para la ruta",
          body: [
            "Cualquier turismo de nuestra flota puede recorrer la Transfăgărășan en buenas condiciones climáticas, aunque un coche con buena tracción es una opción cómoda si viajas en temporada de lluvias.",
            "Todos nuestros vehículos incluyen seguro RCA+CASCO y kilometraje ilimitado, así que puedes completar la ruta completa sin preocuparte por límites de distancia.",
          ],
        },
        {
          h2: "Consejos prácticos para el viaje",
          body: [
            "Sal con el depósito lleno, ya que las gasolineras escasean en los tramos de montaña, y lleva ropa de abrigo incluso en verano, porque la temperatura baja bastante en altura.",
            "Puedes recoger el coche en Bucarest o en el aeropuerto de Otopeni y dirigirte hacia Sibiu o Curtea de Argeș como puntos de acceso a la carretera.",
          ],
        },
      ],
      faqs: [
        { q: "¿Cuándo está abierta la Transfăgărășan?", a: "Generalmente entre finales de junio y finales de octubre, según las condiciones de nieve." },
        { q: "¿Necesito un coche especial para recorrerla?", a: "No es obligatorio, pero un coche con buena tracción es recomendable en días de lluvia." },
        { q: "¿El kilometraje ilimitado cubre esta ruta?", a: "Sí, puedes recorrer toda la carretera sin preocuparte por límites de distancia." },
        { q: "¿Desde dónde puedo empezar la ruta?", a: "Los accesos más habituales son desde Sibiu o Curtea de Argeș, tras recoger el coche en Bucarest u Otopeni." },
      ],
      keywords: "transfagarasan en coche, guia transfagarasan, alquiler coche transfagarasan rumania",
    },
    "guide-transylvania": {
      slug: "guia-ruta-por-transilvania-en-coche",
      title: "Guía: ruta por Transilvania en coche de alquiler",
      description: "Planea tu ruta por Transilvania en coche: castillos, ciudades medievales y consejos prácticos con carentals.ro.",
      eyebrow: "Guía de ruta",
      h1: "Guía para recorrer Transilvania en coche",
      intro: "Transilvania es una de las regiones más fascinantes de Rumanía, con castillos, fortalezas sajonas y paisajes de montaña. Un coche de alquiler te da la libertad de descubrirla sin depender de horarios de transporte público.",
      perks: guidePerks,
      sections: [
        {
          h2: "Puntos imprescindibles de la ruta",
          body: [
            "Brașov, Sighișoara, el castillo de Bran y la ciudadela de Sibiu son paradas clásicas de cualquier ruta por Transilvania, todas ellas bien conectadas por carretera.",
            "Con nuestro kilometraje ilimitado puedes diseñar la ruta que quieras, añadiendo pueblos sajones menos conocidos sin preocuparte por los kilómetros recorridos.",
          ],
        },
        {
          h2: "Cómo organizar la recogida del coche",
          body: [
            "La opción más habitual es recoger el coche gratis en Bucarest o en el aeropuerto de Otopeni y conducir hacia Transilvania, a unas dos o tres horas de la capital según el destino.",
            "Si prefieres empezar la ruta directamente en Cluj, Sibiu o Brașov, podemos coordinar la entrega en esas ciudades bajo petición, con presupuesto según la distancia.",
          ],
        },
        {
          h2: "Consejos para conducir por la región",
          body: [
            "Las carreteras de montaña de Transilvania pueden tener curvas cerradas y tráfico lento en zonas turísticas durante el verano, así que conviene calcular tiempos con margen.",
            "Todos nuestros coches incluyen seguro RCA+CASCO y rovinieta, así que puedes circular por cualquier carretera de la región sin gestiones adicionales.",
          ],
        },
      ],
      faqs: [
        { q: "¿Cuántos días necesito para recorrer Transilvania?", a: "Entre 4 y 7 días es un buen margen para visitar las principales ciudades y castillos con calma." },
        { q: "¿Dónde recojo el coche para empezar la ruta?", a: "Puedes recogerlo gratis en Bucarest u Otopeni, o bajo petición en Cluj, Sibiu o Brașov." },
        { q: "¿Es fácil conducir por Transilvania?", a: "Sí, las carreteras están en buen estado, aunque hay tramos de montaña con curvas que requieren atención." },
        { q: "¿El seguro cubre toda la región?", a: "Sí, el seguro RCA+CASCO y la rovinieta son válidos en toda Transilvania." },
      ],
      keywords: "ruta transilvania en coche, guia transilvania rumania, alquiler coche transilvania",
    },
    "guide-black-sea": {
      slug: "guia-costa-mar-negro-en-coche",
      title: "Guía: ruta por la costa del mar Negro en coche",
      description: "Descubre la costa rumana del mar Negro en coche de alquiler: playas, consejos y logística de viaje con carentals.ro.",
      eyebrow: "Guía de costa",
      h1: "Guía para recorrer la costa del mar Negro en coche",
      intro: "La costa rumana del mar Negro, con Constanța y Mamaia como referencias principales, es un destino de verano perfecto para recorrer en coche de alquiler, con playas, vida nocturna y pueblos tranquilos como Vama Veche.",
      perks: guidePerks,
      sections: [
        {
          h2: "Qué ver en la costa",
          body: [
            "Mamaia es la playa más animada, ideal para quienes buscan ambiente y hoteles frente al mar, mientras que Vama Veche ofrece un ambiente más relajado y bohemio.",
            "Constanța, con su casco histórico y su casino modernista, es una parada obligada entre playa y playa a lo largo de la costa.",
          ],
        },
        {
          h2: "Cómo llegar en coche de alquiler",
          body: [
            "Desde Bucarest, la costa está a poco más de dos horas por autopista, así que puedes recoger el coche gratis en nuestra oficina o en el aeropuerto Otopeni y llegar el mismo día.",
            "Si prefieres recoger el vehículo directamente en Constanța, podemos coordinarlo bajo petición, con presupuesto según la distancia desde Bucarest.",
          ],
        },
        {
          h2: "Consejos para el verano en la costa",
          body: [
            "En temporada alta el tráfico hacia la costa puede ser denso los fines de semana, así que conviene salir con margen, especialmente los viernes por la tarde.",
            "El kilometraje ilimitado te permite moverte libremente entre las distintas playas de la costa sin preocuparte por la distancia recorrida.",
          ],
        },
      ],
      faqs: [
        { q: "¿Cuánto se tarda de Bucarest a la costa?", a: "Aproximadamente dos horas por autopista hasta Constanța o Mamaia." },
        { q: "¿Puedo recoger el coche directamente en Constanța?", a: "Sí, bajo petición y con presupuesto según la distancia desde Bucarest." },
        { q: "¿Cuál es la mejor época para visitar la costa?", a: "De junio a septiembre, con julio y agosto como los meses de más ambiente." },
        { q: "¿El seguro cubre toda la zona costera?", a: "Sí, el seguro RCA+CASCO y la rovinieta son válidos en toda la costa rumana." },
      ],
      keywords: "costa mar negro rumania en coche, ruta mamaia constanta, alquiler coche costa rumania",
    },
    "rules-rovinieta": {
      slug: "guia-rovinieta-rumania",
      title: "Rovinieta en Rumanía: guía completa | carentals.ro",
      description: "Todo sobre la rovinieta rumana: qué es, cuándo se necesita y por qué va incluida en tu alquiler con carentals.ro.",
      eyebrow: "Normas de circulación",
      h1: "Qué es la rovinieta y cómo funciona en Rumanía",
      intro: "La rovinieta es la viñeta obligatoria para circular por las carreteras nacionales de Rumanía. En carentals.ro la incluimos en todos nuestros alquileres, así que no tienes que gestionarla ni pagarla por separado.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Qué es exactamente la rovinieta",
          body: [
            "Se trata de una tasa de uso obligatoria para circular por la red de carreteras nacionales rumanas, similar a una viñeta de autopista en otros países europeos.",
            "Se controla de forma electrónica mediante la matrícula del vehículo, así que no existe ningún ticket físico que colocar en el parabrisas.",
          ],
        },
        {
          h2: "Por qué no debes preocuparte al alquilar con nosotros",
          body: [
            "Todos los coches de nuestra flota circulan con la rovinieta pagada y vigente durante toda la duración del alquiler, sin coste adicional ni gestión por tu parte.",
            "Esto te evita el riesgo de multas por circular sin la viñeta en regla, un error habitual entre quienes viajan por primera vez a Rumanía.",
          ],
        },
        {
          h2: "Qué pasa si circulas sin rovinieta",
          body: [
            "Circular sin rovinieta puede conllevar multas significativas en Rumanía, controladas mediante cámaras y sistemas electrónicos en las principales carreteras.",
            "Al alquilar con carentals.ro te olvidas de este riesgo, ya que la viñeta está incluida y activa desde el primer día de tu alquiler.",
          ],
        },
      ],
      faqs: [
        { q: "¿Tengo que pagar la rovinieta por separado?", a: "No, va incluida en el precio de todos nuestros alquileres." },
        { q: "¿Cómo se controla la rovinieta?", a: "De forma electrónica, mediante cámaras que leen la matrícula del vehículo." },
        { q: "¿Qué pasa si circulo sin rovinieta?", a: "Puedes recibir una multa; por eso siempre incluimos la viñeta vigente en nuestros coches." },
        { q: "¿La rovinieta cubre todo el país?", a: "Sí, cubre la red de carreteras nacionales de toda Rumanía." },
      ],
      keywords: "rovinieta rumania, que es la rovinieta, vinieta carretera rumania",
    },
    "rules-winter-tires": {
      slug: "guia-neumaticos-de-invierno-rumania",
      title: "Neumáticos de invierno en Rumanía: guía práctica",
      description: "Cuándo son obligatorios los neumáticos de invierno en Rumanía y cómo lo gestionamos en carentals.ro.",
      eyebrow: "Normas de circulación",
      h1: "Neumáticos de invierno: qué debes saber en Rumanía",
      intro: "En Rumanía, la normativa exige neumáticos de invierno o cadenas en condiciones de nieve o hielo. En carentals.ro equipamos nuestros vehículos según la temporada para que conduzcas con seguridad, sin gestiones adicionales por tu parte.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Cuándo son obligatorios",
          body: [
            "La ley rumana exige que los vehículos circulen con neumáticos de invierno, cadenas o equipamiento equivalente en carreteras cubiertas de nieve, hielo o escarcha, principalmente entre noviembre y marzo.",
            "Esta normativa se aplica de forma general en todo el país, con especial atención en zonas de montaña como los Cárpatos o la carretera Transfăgărășan.",
          ],
        },
        {
          h2: "Cómo lo gestionamos en carentals.ro",
          body: [
            "Durante la temporada fría equipamos nuestra flota con neumáticos adecuados para las condiciones invernales, así que no tienes que preocuparte por cambiarlos ni verificarlos tú mismo.",
            "Si tu viaje incluye zonas de alta montaña en invierno, te recomendamos avisarnos por WhatsApp para confirmar el equipamiento específico del vehículo que necesitas.",
          ],
        },
        {
          h2: "Consejos para conducir en invierno",
          body: [
            "Reduce la velocidad en tramos con hielo o nieve y aumenta la distancia de seguridad, especialmente en carreteras de montaña con curvas.",
            "Lleva siempre el depósito con suficiente combustible y ropa de abrigo en el coche si viajas por zonas rurales o de montaña durante el invierno.",
          ],
        },
      ],
      faqs: [
        { q: "¿Es obligatorio usar neumáticos de invierno en Rumanía?", a: "Sí, en condiciones de nieve, hielo o escarcha, principalmente entre noviembre y marzo." },
        { q: "¿Vuestros coches ya llevan neumáticos de invierno en esa época?", a: "Sí, equipamos la flota según la temporada para que no tengas que gestionarlo tú." },
        { q: "¿Puedo pedir un coche con neumáticos de invierno reforzados?", a: "Sí, escríbenos por WhatsApp si tu ruta incluye zonas de alta montaña." },
        { q: "¿Qué zonas requieren más precaución en invierno?", a: "Los Cárpatos y carreteras de montaña como la Transfăgărășan, que puede cerrarse en invierno." },
      ],
      keywords: "neumaticos de invierno rumania, normativa neumaticos rumania, conducir en invierno rumania",
    },
    "rules-speed-cameras": {
      slug: "guia-radares-de-velocidad-rumania",
      title: "Radares de velocidad en Rumanía: guía práctica",
      description: "Cómo funcionan los radares y controles de velocidad en Rumanía, y consejos para evitar multas durante tu alquiler.",
      eyebrow: "Normas de circulación",
      h1: "Radares de velocidad en Rumanía: lo que debes saber",
      intro: "Rumanía cuenta con numerosos radares fijos y móviles para controlar la velocidad, tanto en autopistas como en travesías urbanas. Te contamos cómo funcionan para que conduzcas tranquilo con tu coche de alquiler.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Dónde se controlan los límites de velocidad",
          body: [
            "Los radares en Rumanía se encuentran tanto en carreteras nacionales y autopistas como en el interior de pueblos y ciudades, donde los límites bajan considerablemente.",
            "Es habitual encontrar controles policiales con radar móvil, especialmente en las entradas y salidas de localidades y en tramos de alta siniestralidad.",
          ],
        },
        {
          h2: "Límites de velocidad habituales",
          body: [
            "En general, el límite es de 50 km/h en zonas urbanas, 90 km/h en carreteras nacionales y hasta 130 km/h en autopistas, salvo señalización distinta.",
            "Te recomendamos prestar atención a la señalización local, ya que algunos tramos reducen el límite de forma puntual por obras o condiciones de la vía.",
          ],
        },
        {
          h2: "Qué hacer si recibes una multa",
          body: [
            "Si recibes una notificación de multa después de devolver el vehículo, puedes contactarnos por WhatsApp al +40738792499 y te orientamos sobre los pasos a seguir.",
            "Conducir dentro de los límites establecidos es la mejor forma de disfrutar tu viaje sin sorpresas económicas al regresar a casa.",
          ],
        },
      ],
      faqs: [
        { q: "¿Hay muchos radares en Rumanía?", a: "Sí, tanto fijos como móviles, especialmente en accesos a pueblos y carreteras nacionales." },
        { q: "¿Cuáles son los límites de velocidad generales?", a: "50 km/h en ciudad, 90 km/h en carretera nacional y hasta 130 km/h en autopista." },
        { q: "¿Qué hago si me llega una multa tras el viaje?", a: "Contáctanos por WhatsApp y te ayudamos a entender el proceso a seguir." },
        { q: "¿El seguro cubre las multas de tráfico?", a: "No, las multas de tráfico son responsabilidad del conductor, independientemente del seguro del vehículo." },
      ],
      keywords: "radares rumania, limites de velocidad rumania, multas de trafico rumania",
    },
    "airport-pickup": {
      slug: "como-recoger-el-coche-en-el-aeropuerto-otopeni",
      title: "Cómo recoger tu coche en el aeropuerto Otopeni: guía paso a paso",
      description: "Guía paso a paso para recoger tu coche de alquiler en el aeropuerto Otopeni de Bucarest con carentals.ro, sin depósito ni tarjeta de crédito.",
      eyebrow: "Guía de recogida",
      h1: "Cómo recoger tu coche en el aeropuerto de Otopeni: paso a paso",
      intro: "Recoger tu coche de alquiler en el aeropuerto Henri Coandă de Otopeni es un proceso sencillo y rápido con carentals.ro. Te explicamos exactamente qué hacer desde que aterrizas hasta que sales conduciendo.",
      perks: otopeniPerks,
      sections: [
        {
          h2: "Paso 1: confirma tu vuelo por WhatsApp",
          body: [
            "Antes de viajar, envíanos por WhatsApp al +40738792499 los datos de tu vuelo y la hora estimada de llegada, para que nuestro equipo esté preparado en el aeropuerto.",
            "Si tu vuelo se retrasa, avísanos en cuanto lo sepas: ajustamos la hora de entrega sin coste adicional, incluso si llegas de madrugada.",
          ],
        },
        {
          h2: "Paso 2: recoge tu equipaje y contacta con nuestro equipo",
          body: [
            "Una vez recojas tu equipaje en la terminal del aeropuerto Otopeni, escríbenos o llámanos para confirmar tu llegada y coordinar el punto exacto de encuentro.",
            "Nuestro representante te indicará dónde encontrarte, normalmente en una zona cercana a las salidas de la terminal, para entregarte el vehículo sin demoras.",
          ],
        },
        {
          h2: "Paso 3: revisa el coche y firma el contrato",
          body: [
            "Antes de salir, revisamos juntos el estado del vehículo y te explicamos brevemente sus características. No se requiere depósito de seguridad ni tarjeta de crédito para firmar el contrato.",
            "Puedes pagar en ese momento con tarjeta de débito, en efectivo (EUR o RON) o por transferencia bancaria previa, y después solo queda subir al coche y comenzar tu viaje por Rumanía.",
          ],
        },
      ],
      faqs: [
        { q: "¿Dónde exactamente me entregan el coche en Otopeni?", a: "En una zona designada cerca de las salidas de la terminal; te indicamos el punto exacto por WhatsApp." },
        { q: "¿Qué pasa si mi vuelo llega muy tarde por la noche?", a: "No hay problema, nuestro servicio de recogida en Otopeni funciona las 24 horas del día." },
        { q: "¿Necesito llevar algo especial para la recogida?", a: "Solo tu documento de identidad o pasaporte y el carné de conducir vigente." },
        { q: "¿Debo pagar algún depósito al recoger el coche?", a: "No, no exigimos depósito de seguridad ni tarjeta de crédito para la recogida." },
      ],
      keywords: "recoger coche aeropuerto otopeni, como alquilar coche en otopeni, guia recogida coche bucarest aeropuerto",
    },
  },
};
